import {InPageAlert, TextLink} from '@snsw-gel/react';
import React from 'react';
import {SoleTraderFailure} from '../../services/api-services';
import config from '../../config/config';
import {PhoneElement} from '../../utils/elements';

interface ApiErrorAlertProps {
    readonly errorReason: SoleTraderFailure;
}

// TODO remove this file after Tr2 decom
const ApiErrorAlert: React.FC<ApiErrorAlertProps> = ({errorReason}) => {
    const [title, description] = errorTitleAndDescription(errorReason);

    return <InPageAlert variant='error' title={title} role='alert'>
        {description}
    </InPageAlert>;
};

function errorTitleAndDescription(errorReason: SoleTraderFailure): [string, React.JSX.Element] {
    let title: string;
    let description: React.JSX.Element;
    switch (errorReason) {
        case SoleTraderFailure.abnInactive:
            title = 'Unable to link this toll account';
            description = <>
                <p>Your Australian Business Number (ABN) is inactive.</p>
                <p>To be eligible, businesses must have an active ABN. This needs to be active from the start of the current
                    financial year. Learn more about {' '}
                    <TextLink isExternal href={config.links.soleTraderEligibilityLink}
                    >eligibility criteria
                    </TextLink>.
                </p>

            </>;
            break;
        case SoleTraderFailure.unauthorised:
            title = 'We cannot link this toll account';
            description = <>
                <p>You're currently unauthorised to act on behalf of this business. You might not be registered via the{' '}
                    <TextLink isExternal
                              href={config.links.australianBusinessRegister}
                    >Australian Business Register
                    </TextLink>.
                </p>
            </>;
            break;
        case SoleTraderFailure.abnAlreadyLinked:
            title = 'Unable to link this toll account';
            description = <>
                <p>Your ABN is already linked to another MyServiceNSW account.</p>
                <p>Only one ABN can be linked to a MyServiceNSW account.</p>
                <p>If you need assistance, call us on {PhoneElement}.</p>
            </>;
            break;
        case SoleTraderFailure.anzsicViolation:
            title = 'Unable to link this toll account';
            description = <>
                <p>Your Australian and New Zealand Standard Industrial Classification (ANZSIC) indicates your business operates
                    a taxi or ride-share service.</p>
                <p>To be eligible, businesses must not operate taxi or ride-share services. Learn about the{' '}
                    <TextLink isExternal
                              href={config.links.soleTraderEligibilityLink}
                    >eligibility criteria
                    </TextLink>.
                </p>
            </>;
            break;
        case SoleTraderFailure.abnSuppressed:
            title = 'Unable to link this toll account';
            description = <>
                <p>We’re unable to verify your ABN and business details.</p>
            </>;
            break;
        case SoleTraderFailure.businessNotInNSW:
            title = 'We cannot link this toll account';
            description = <>
                <p>Your business is not registered in NSW. To be eligible, businesses must operate in NSW. Learn about the{' '}
                    <TextLink isExternal
                              href={config.links.soleTraderEligibilityLink}
                    >eligibility criteria
                    </TextLink>.
                </p>
            </>;
            break;
        case SoleTraderFailure.abnNotSoleTrader:
            title = 'Unable to link this toll account';
            description =
                <>
                    <p>We&apos;re unable to verify your ABN and business details.</p>
                </>
    }

    return [title, description];
}

export default ApiErrorAlert;
